<template>
    <v-container class="notranslate" v-if="!allChecksPassed" transparent style="max-width: 1200px">
        <v-card-title class="pa-4 title">Что нужно сделать теперь?</v-card-title>

        <v-timeline :dense="$vuetify.breakpoint.mdAndDown">
            <v-timeline-item icon="person" class="notranslate" fill-dot
                             :color="($store.state.user.allFieldsFull && 'grey') || 'primary'">
                <v-card outlined class="pa-2">
                    <v-card-title :class="`headline ${$store.state.user.allFieldsFull && 'grey'}--text`">Заполнить
                        основной профиль
                    </v-card-title>
                    <template v-if="!$store.state.user.allFieldsFull">
                        <v-card-text>
                            Закончите заполнение профиля пользователя - телефон, место жительства, день рождения

                        </v-card-text>
                        <v-card-actions>
                            <v-btn class="ml-1" color="primary" to="/home/profile">
                                <v-icon class="notranslate mr-2">person</v-icon>
                                Заполнить
                            </v-btn>
                        </v-card-actions>
                    </template>
                    <template v-else>
                        <v-card-text>
                            Этот шаг выполнен!
                        </v-card-text>
                    </template>
                </v-card>
            </v-timeline-item>

            <v-timeline-item icon="library_books" class="notranslate" fill-dot
                             :color="($store.state.tests.length && 'grey') || 'primary'">
                <v-card outlined class="pa-2">
                    <v-card-title class="headline">Зарегистрировать тест</v-card-title>
                    <template v-if="!$store.state.tests.length">
                        <v-card-text>
                            Вам необходимо зарегистрировать свой тест в системе. Приготовьте карточку с номером из
                            набора
                            для взятия анализа, и введите код (ZK-XXXXXX-XXXXXX) с карточки без префикса ZK-
                            <RegTest></RegTest>
                        </v-card-text>
                    </template>
                    <template v-else>
                        <v-card-text>
                            Этот шаг выполнен!
                        </v-card-text>
                    </template>
                </v-card>
            </v-timeline-item>

        </v-timeline>
    </v-container>
    <v-container v-else style="max-width: 2200px">
        <v-card-title class="pa-4 title">Ваши тесты -
            <template v-for="testcode in this.$store.state.tests">
                <template v-for="box in testcode.boxes">
                    &nbsp;{{ box.zn }}
                </template>
            </template>
        </v-card-title>


        <v-container fluid fill-height>
            <v-layout wrap fill-height>
                <v-flex xl6 lg6 md6 sm12 xs12 align-end flexbox>
                    <v-card  fill-height flat color="#fcfcfc" class="ma-2 pa-2">
                        <v-card-title class="headline">Файлы</v-card-title>
                        <v-card-text>
                            Вы можете скачать результаты исследования в виде файлов
                        </v-card-text>
                        <v-card-actions>
                            <v-btn light to="/home/tests/download/">
                                Скачать
                                <v-icon class="notranslate" right>mdi-cloud-download</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
                <v-flex  fill-height xl6 lg6 md6 sm12 xs12>
                    <v-card  fill-height flat color="#fcfcfc" class="ma-2 pa-2">
                        <v-card-title class="headline">Комбинированный отчет</v-card-title>
                        <v-card-text>
                            Открыть комбинированный отчет
                        </v-card-text>
                        <v-card-actions>
                            <v-btn dark to="/home/report/combo">
                                Открыть
                                <v-icon class="notranslate" right>mdi-card-bulleted</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>




        <v-list>

            <v-list-item v-if="false" to="/home/tests/download/"  class="py-3">
                <v-list-item-action>
                    <v-icon class="notranslate">mdi-cloud-download</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    Скачать файлы с результатами исследования
                </v-list-item-content>
            </v-list-item>

            <v-divider v-if="false"></v-divider>

            <v-list-item v-if="false" to="/home/report/combo" class="py-3">
                <v-list-item-action>
                    <v-icon class="notranslate">mdi-card-bulleted</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    Загрузить комбинированный отчет
                </v-list-item-content>
            </v-list-item>

            <v-divider v-if="true"></v-divider>


            <v-list-item>
                <v-list-item-action>
                    <v-icon class="notranslate">mdi-card-bulleted</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        Отчеты
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-container fluid>
                <v-layout wrap >
                    <v-flex  xl3 lg4 md6 sm6 xs12 v-for="card in this.$store.state.interpretations" :key="card.id">
                        <v-card dark class="ma-2 pa-2" :color="(reportColors[card.reporttype.template])?reportColors[card.reporttype.template].bkg:reportColors.other.bkg" :style="(reportColors[card.reporttype.template])?reportColors[card.reporttype.template].style||reportColors.other.style:reportColors.other.style">
                            <v-card-title class="headline" fill-height  style="min-height:100px;align-content: flex-start">{{card.reporttype.nameNational}}</v-card-title>

                            <v-card-text>
                                <div v-if="card.status.value===9">
                                    Готов <v-icon class="notranslate">mdi-check</v-icon>
                                </div>
                                <div v-else>
                                    В работе <v-icon class="notranslate">mdi-rotate-right</v-icon>
                                </div>
                                {{card.reporttype.template}}, версия {{card.reporttype.version}}</v-card-text>

                            <v-card-actions>
                                <v-btn light elevation="2" :color="(reportColors[card.reporttype.template])?reportColors[card.reporttype.template].btn:reportColors.other.btn" :to="'/home/report/get/'+card.id+'/ru/'">
                                    Открыть
                                    <v-icon class="notranslate" right dark>mdi-launch</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-data-table class="py-3" v-if="false"
                  :headers="utility.headers"
                  :items="this.$store.state.interpretations"
                  :loading="utility.dataLoading"
                  :rows-per-page-items='[ 10, 25, 50, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]'
                  pagination.sync="{rowsPerPage:10}"
                  calculate-widths=true
            >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template v-slot:items="props">
                    <td width="20%" class="text-xs-left">{{ props.item.id }}</td>
                    <td width="50%" class="text-xs-left">{{ props.item.reporttype.nameNational }}</td>
                    <td width="20%" class="text-xs-left">
                        <v-icon class="notranslate" color="green" v-if="props.item.status.value===9">mdi-check</v-icon>
                        <v-icon class="notranslate" color="grey" v-else>mdi-rotate-right</v-icon>
                    </td>
                    <td width="20%" class="text-xs-left">
                        <v-btn flat small v-if="props.item.status.value===9"
                               :to="'/home/report/get/'+props.item.id+'/ru/'">
                            Открыть
                            <v-icon class="notranslate" right dark>mdi-launch</v-icon>
                        </v-btn>
                    </td>
                </template>
            </v-data-table>
        </v-list>

    </v-container>
</template>

<script>
    import RegTest from './RegTestBare'

    export default {
        name: "UserDashboard",
        components: {RegTest},
        methods: {},
        computed: {
            allChecksPassed: function () {
              return this.$store.state.user.checks.agenda & this.$store.state.user.checks.profile & (this.$store.state.user.testcodes.length>0)
                //return this.$store.state.user.allFieldsFull & (this.$store.state.tests.length > 0)
            },
        },
        data: () => ({
            reportColors: {
                fitness: {bkg:'#ff0000', btn: '#ccc', style: "background-color: #3db7a4; background-image: linear-gradient(45deg, #0d7030, #6ac3d3)"},
                beauty: {bkg:'#eb5f21', btn: '', style: "background-color: #eb5f21; background-image: linear-gradient(45deg, #eb5f21, #f7eb49)"},
                ethnic: {bkg:'#7ccad7', btn: '', style: "background-color: #203d67; background-image: linear-gradient(45deg, #203d67, #7ccad7)"},
                bacterial: {bkg:'#ff0000', btn: '', style: "background-color: #18303c; background-image: linear-gradient(45deg, #18303c, #eef3f6)"},
                other: {bkg:'#999999', btn: '#fff', style: "background-color: #999999; background-image: linear-gradient(45deg, #666, #aaa)"},
            },

            utility: {
                headers: [
                    {text: 'Id отчета', value: '_id'},
                    {text: 'Заголовок', value: 'title'},
                    {text: 'Готов', value: 'isReady'},
                    {text: 'Открыть', value: '_id'},
                ]

            }
        }),
        props: {}


    }
</script>

